import { render } from "./how-to-pay.vue?vue&type=template&id=210f057c&scoped=true"
import script from "./how-to-pay.vue?vue&type=script&lang=js"
export * from "./how-to-pay.vue?vue&type=script&lang=js"

import "./how-to-pay.vue?vue&type=style&index=0&id=210f057c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210f057c"]])

export default __exports__